<template>
  <div class="school-box" @click="toSchoolLiveList">
    <div class="school-info">
      <el-image class="school-logo" :src="schoolData.logo" />
      <span class="school-name">{{ schoolData.name }}</span>
      <div class="live-count">{{ schoolData.live_num }}场</div>
    </div>
    <div class="school-location">
      <i class="el-icon-location" />
      <span>{{ schoolData.province }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    schoolData: {
      type: Object,
      required: true
    }
  },
  methods: {
    toSchoolLiveList() {
      this.$router.push(`/m/broadcast/list/${this.schoolData.id}`);
    }
  }
}
</script>

<style lang="less" scoped>
.school-box {
  width: 100%;
  height: 8.25rem;
  display: flex;
  flex-direction: column;
  background-color: #FFFFFF;
  border-radius: 0.75rem;
  overflow: hidden;

  .school-info {
    flex: 1;
    width: 100%;
    padding: 0.75rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.325rem;

    .school-logo {
      width: 2rem;
      height: 2rem;
    }

    .school-name {
      width: 100%;
      font-size: 0.875rem;
      text-align: center;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .live-count {
      font-size: 0.875rem;
      color: #66D5C8;
    }
  }

  .school-location {
    width: 100%;
    height: 1.5rem;
    background-color: #F3F8FF;
    color: #2173EA;
    font-size: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
  }
}
</style>
